import * as dotProp from 'dot-prop-immutable';
import cloneDeep from 'lodash/cloneDeep';
import {
  ALL_SEARCH_ERROR,
  ALL_SEARCH_RESULTS,
  CLEAR_DELETED_SEARCH_RESULT,
  CLEAR_SELECTED_TICKET_RESULT,
  SELECT_TICKET_SEARCH_RESULT,
  SET_DELETED_SEARCH_RESULT,
  SET_QUERY_FOR_LDA,
  SET_RESULT_INDEX,
  SET_SEARCH_ID,
  SET_PARTNER_PLATFORM_HISTORICAL_TICKETS,
  UPDATE_PARTNER_PLATFORM_HISTORICAL_TICKET,
  CLEAR_ALL_TICKET,
  CLEAR_ASSIGNED_TICKET,
  CLEAR_NOMINATED_TICKET,
  CLEAR_SEARCH,
} from '../../actions/types';
import { getAlgoliaResultHits } from '../../util/kbUtil';

const initialSelectedResult = {
  resultType: '',
  resultIndex: -1,
};

const initialTicketSearchState = {
  selectedResult: initialSelectedResult,
  macroResults: [],
  kbResults: [],
  ticketResults: [],
  deletedResultsById: {},
  partnerPlatformHistoricalTickets: [],
  query: '',
  error: null,
  searchId: null, // for search analytics tracking
};

const ticketSearch = (state = { ...initialTicketSearchState }, action) => {
  switch (action.type) {
    case ALL_SEARCH_RESULTS:
      return {
        ...state,
        macroResults: getAlgoliaResultHits(action.macroResults),
        kbResults: getAlgoliaResultHits(action.kbResults),
        ticketResults: getAlgoliaResultHits(action.ticketResults),
        query: action.query,
        selectedResult: initialSelectedResult,
        error: null,
      };
    case SET_PARTNER_PLATFORM_HISTORICAL_TICKETS:
      return Object.assign({}, state, { partnerPlatformHistoricalTickets: action.payload });
    case UPDATE_PARTNER_PLATFORM_HISTORICAL_TICKET:
      const { updatedTicket, index } = action;
      const { partnerPlatformHistoricalTickets } = state;

      const updatedPartnerPlatformHistoricalTickets = cloneDeep(partnerPlatformHistoricalTickets);
      updatedPartnerPlatformHistoricalTickets[index] = updatedTicket;

      return Object.assign({}, state, { partnerPlatformHistoricalTickets: updatedPartnerPlatformHistoricalTickets });
    case SET_QUERY_FOR_LDA:
      return {
        ...state,
        query: action.query,
      };
    case SELECT_TICKET_SEARCH_RESULT:
      return { ...state, selectedResult: { resultType: action.resultType, resultIndex: action.resultIndex } };
    case SET_RESULT_INDEX:
      return dotProp.set(state, 'selectedResult.resultIndex', action.resultIndex);
    case ALL_SEARCH_ERROR:
      return {
        ...state,
        macroResults: [],
        kbResults: [],
        ticketResults: [],
        partnerPlatformHistoricalTickets: [],
        // query: '',
        selectedResult: initialSelectedResult,
        error: action.error,
      };
    case CLEAR_SEARCH:
    case CLEAR_NOMINATED_TICKET:
    case CLEAR_ASSIGNED_TICKET:
    case CLEAR_ALL_TICKET:
      return initialTicketSearchState;
    case SET_DELETED_SEARCH_RESULT:
      return dotProp.set(state, `deletedResultsById.${action.uniqueId}`, action.result);

    case CLEAR_DELETED_SEARCH_RESULT:
      return dotProp.delete(state, `deletedResultsById.${action.uniqueId}`);
    case SET_SEARCH_ID:
      return { ...state, searchId: action.searchId };
    case CLEAR_SELECTED_TICKET_RESULT:
      return dotProp.set(state, 'selectedResult', initialSelectedResult);

    default:
      return state;
  }
};

export default ticketSearch;
